import { zodResolver } from "@hookform/resolvers/zod";
import {
  type DefaultValues,
  type FieldValues,
  type Resolver,
  type UseFormReturn,
  useForm,
} from "react-hook-form";
import { type z } from "zod";

export const useFormResolver = <
  TValues extends FieldValues,
>({
  schema,
  defaultValues,
}: {
  schema: z.ZodTypeAny;
  defaultValues: DefaultValues<TValues>;
}): UseFormReturn<TValues, unknown, TValues> =>
  useForm<TValues, unknown, TValues>({
    resolver: zodResolver(schema as never) as Resolver<TValues, unknown, TValues>,
    defaultValues,
  });
